import React, { FC, ReactNode } from "react";
import { Typography } from "@mui/material";

interface Props {
  isSmallScreen: boolean;
  totalUnits: number;
  totalPanels: number;
}

const Footer: FC<Props> = ({ isSmallScreen, totalPanels, totalUnits }) => {
  if (isSmallScreen) {
    return (
      <>
        <FooterText># of Units: {totalUnits}</FooterText>
        <FooterText># of Doors: {totalPanels}</FooterText>
      </>
    );
  }
  return (
    <>
      <FooterText>(* As Viewed From Exterior)</FooterText>
      <FooterText>Total Number of Units: {totalUnits}</FooterText>
      <FooterText>Total Number of Doors: {totalPanels}</FooterText>
    </>
  );
};

interface FooterTextProps {
  children: ReactNode;
}

const FooterText: FC<FooterTextProps> = ({ children }) => {
  return (
    <Typography style={{ fontWeight: "bold" }} variant="caption">
      {children}
    </Typography>
  );
};

export default Footer;
